import { Link, DialogContentText } from '@mui/material'
import { ReactNode, useState } from 'react'
import { LayoutDialog } from '@flatsy/core'
import Separator from '@flatsy/core/Layout/Separator'

interface LamyPrivacyNoticeProps {
  trigger?: ReactNode
}

export const LamyPrivacyNotice: React.FC<LamyPrivacyNoticeProps> = ({ trigger }) => {
  const [showLamy, setShowLamy] = useState(false)

  const handleCloseLamy = () => {
    setShowLamy(false)
  }

  const handleOpenLamy = (e: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    e.preventDefault()
    setShowLamy(true)
  }

  return (
    <>
      <Link href="lamy" variant="body1" onClick={handleOpenLamy}>
        {trigger}
      </Link>
      <LayoutDialog
        onClose={handleCloseLamy}
        open={showLamy}
        title="Concernant la collecte et le traitement des données"
        maxWidth="sm"
      >
        <div>
          <DialogContentText sx={{ textAlign: 'center' }}>
            Nous vous informons que les informations de votre dossier sont traitées par LAMY dans le
            cadre de votre demande de visite et de l’analyse de votre solvabilité. Le fondement
            légal de ces traitements est la mise en œuvre des mesures précontractuelles.
          </DialogContentText>
          <Separator size="16px" />
          <DialogContentText sx={{ textAlign: 'center' }}>
            LAMY en sa qualité de responsable de traitement, collecte et réalise des traitements de
            données à caractère personnel dans le cadre de la commercialisation de biens à louer
            comprenant notamment l’étude de dossier de candidat locataire et la relation
            contractuelle qui découle de cette sélection. Ces traitements sont fondés sur la base de
            votre consentement préalable.
          </DialogContentText>
          <Separator size="16px" />
          <DialogContentText sx={{ textAlign: 'center' }}>
            Les données collectées sont destinées aux services concernés de LAMY et plus
            généralement du Groupe EVORIEL et le cas échéant à ses sous-traitants et prestataires.
            Ces derniers sont soumis à une obligation de confidentialité et ne peuvent utiliser vos
            données qu’en conformité avec nos dispositions contractuelles et la législation
            applicable.
          </DialogContentText>
          <Separator size="16px" />
          <DialogContentText sx={{ textAlign: 'center' }}>
            Vous avez la possibilité d’exercer vos droits pour accéder, rectifier, effacer vos
            données, limiter leurs traitements, vous y opposer et demander la portabilité de
            celles-ci en suivant la procédure prévue sur le lien
            https://app.witik.io/fr/form/lamy/formulaire-rgpd ou par courrier postal à l’attention
            du Délégué à la Protection des données – LAMY – 19 rue de Vienne – TSA 10034 – 75801
            PARIS Cedex 08, accompagné d’une copie d’un titre d’identité.
          </DialogContentText>
          <Separator size="16px" />
          <DialogContentText sx={{ textAlign: 'center' }}>
            Vous pouvez également adresser une réclamation auprès de la Commission Nationale de
            l’informatique et des liberté – 3 place de Fontenoy – TSA 80715 – 75334 PARIS Cedex 08.
          </DialogContentText>
        </div>
      </LayoutDialog>
    </>
  )
}

export default LamyPrivacyNotice
